import React from 'react';
import { Card, Col, Row, Button, Modal, Form } from 'react-bootstrap';
import '../candidateProfileSubContentPane/candidateProfessionalMembership.css';
import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen, faPlusCircle, faMinusCircle } from '@fortawesome/free-solid-svg-icons';
import _ from 'lodash';
import CloseIcon from '../../../assets/images/Ic_close.png';
import ReactDatePicker from 'react-datepicker';
import { getErrorClass, getErrorMessage } from '../../../utils/errorUtils';
import { CandidatePostLoginService } from '../../../services/candidatePostLoginService';

const CandidateProfessionalMembershipContent = ({ professionalReferences = [], professionalMemberships = [], setProfessionalMemberships, setProfessionalReferences }) => {
  const [showRefModal, setShowRefModal] = useState(false);
  const [showMemModal, setShowMemModal] = useState(false);
  const [editedReferences, setEditedReferences] = useState([]);
  const [editedMemberships, setEditedMemberships] = useState([]);
  const [savingMemberships, setSavingMemberships] = useState(false);
  const [saveError, setSaveError] = useState(null);
  const [errorMessage, setErrorMessage] = useState('');
  const [errors, setErrors] = useState({});
  const [savingReference, setSavingReference] = useState(false);
  const [savingMembership, setSavingMembership] = useState(false);

  // References
  const [showAddRefModal, setShowAddRefModal] = useState(false);
  const [newReference, setNewReference] = useState({
    name: '',
    organisation: '',
    phoneNumber: '',
    designation: ''
  });

  // Memberships
  const [showAddMemModal, setShowAddMemModal] = useState(false);
  const [newMembership, setNewMembership] = useState({
    name: '',
    year: ''
  });



  const handleOpenRefModal = () => {
    const deepCopiedReferences = (professionalReferences || []).map(ref => ({ ...ref }));
    setEditedReferences(deepCopiedReferences);
    setShowRefModal(true);
  };

  const handleOpenMemModal = () => {
    const deepCopiedMemberships = (professionalMemberships || []).map(mem => ({ ...mem }));
    setEditedMemberships(deepCopiedMemberships);
    setShowMemModal(true);
  };


  const handleCloseRefModal = () => {
    setErrors({});
    setSaveError(null);
    setEditedReferences(professionalReferences || []);
    setShowRefModal(false);
  };
  const handleCloseAddRefModal = () => {
    setErrors({});
    setSaveError(null);
    setNewReference({ name: '', organisation: '', phoneNumber: '', designation: '' });
    setShowAddRefModal(false);
  };

  const handleCloseAddMemModal = () => {
    setErrors({});
    setSaveError(null);
    setErrorMessage(null);
    setNewMembership({ name: '', year: '' });
    setShowAddMemModal(false);
  };


  const handleCloseMemModal = () => {
    setErrors({});
    setSaveError(null);
    setErrorMessage(null);
    setEditedMemberships(professionalMemberships || []);
    setShowMemModal(false);
  };

  const handleRefChange = (index, field, value) => {
    const updated = [...editedReferences];
    updated[index][field] = value;
    setEditedReferences(updated);

    validateField(index, field, value);
  };

  const validateField = (index, field, value) => {
    let error = '';

    const val = (value || '').toString().trim();

    switch (field) {
      case 'name':
        if (!val || !/^[A-Za-z\s]{2,100}$/.test(val)) {
          error = 'Please enter a valid Name. It should contain only alphabets (2–100 characters).';
        }
        break;

      case 'organisation':
        if (!val || !/^[A-Za-z0-9\s.,]{2,100}$/.test(val)) {
          error = 'Please enter a valid Organisation. Allowed: letters, numbers, dot (.), comma (,) — 2–100 characters.';
        }
        break;

      case 'phoneNumber':
        if (!val || !/^\+\d{1,4}\d{10}$/.test(val)) {
          error = 'Please enter a valid phone number with country code. Format: +<code><10-digit-number> (e.g. +919087654323)';
        }
        break;

      case 'designation':
        if (!val || !/^[A-Za-z\s]{2,50}$/.test(val)) {
          error = 'Please enter a valid Designation. It should contain only alphabets (2–50 characters).';
        }
        break;

      default:
        break;
    }

    setErrors(prevErrors => {
      const newErrors = { ...prevErrors };

      if (error) {
        newErrors[`${field}_${index}`] = error;
      } else {
        delete newErrors[`${field}_${index}`];
      }

      return newErrors;
    });
  };

  const validateMembershipField = (index, field, value) => {
    let error = '';
    const val = (value || '').toString().trim();

    if (field === 'name' && val && !/^[A-Za-z\s]{2,50}$/.test(val)) {
      error = 'Name must be 2-50 letters only';
    }

    setErrors(prevErrors => {
      const newErrors = { ...prevErrors };
      const key = `membership_${field}_${index}`;

      if (error) {
        newErrors[key] = error;
      } else {
        delete newErrors[key];
      }
      return newErrors;
    });
  };

  const handleMemChange = (index, field, value) => {
    const updated = [...editedMemberships];
    updated[index][field] = value;
    setEditedMemberships(updated);

    validateMembershipField(index, field, value);
  };

  const handleRemoveReference = (index) => {
    const updated = [...editedReferences];
    updated.splice(index, 1);
    setEditedReferences(updated);
  };

  const handleRemoveMembership = (index) => {
    const updated = [...editedMemberships];
    updated.splice(index, 1);
    setEditedMemberships(updated);
  };



  return (
    <div className="membership-container">
      {errorMessage && (
        <div className="custom-alert-overlay">
          <div className="custom-alert-box">
            <div className="custom-alert-content">
              <p>{errorMessage}</p>
              <button className="custom-alert-button" onClick={() => setErrorMessage('')}>
                OK
              </button>
            </div>
          </div>
        </div>
      )}
      {/* Professional References */}
      <div className="membership-card">
        <Card>
          <Card.Body className={`professionalMembershipPanel pd-1 ${professionalReferences?.length === 0 ? 'emptyCard' : ''}`}>
            <div className="d-flex justify-content-between align-items-center">
              <h5 className="professionalMembershipTitle">Professional Reference</h5>
              {professionalReferences?.length > 0 ? (
                <FontAwesomeIcon
                  icon={faPen}
                  size="sm"
                  onClick={handleOpenRefModal}
                  style={{ color: '#f35824', cursor: 'pointer' }}
                />
              ) : (
                <div
                  className="add-action"
                  onClick={() => setShowAddRefModal(true)}
                  style={{ color: '#F35824', cursor: 'pointer', fontWeight: '500' }}
                >
                  <FontAwesomeIcon icon={faPlusCircle} /> Add Reference
                </div>
              )}
            </div>
            {professionalReferences?.length > 0 && (
              <div className="w-100 text-end mt-2">
                <div
                  onClick={() => setShowAddRefModal(true)}
                  style={{ color: '#F35824', cursor: 'pointer', fontWeight: '500' }}
                >
                  <FontAwesomeIcon icon={faPlusCircle} /> Add Reference
                </div>
              </div>
            )}

            {professionalReferences?.length > 0 ? (
              professionalReferences.map((reference, index) => (
                <div key={index}>
                  <Row>
                    <Col className="professionalMembershipSubTitle mt-3">Name</Col>
                    <Col className="professionalMembershipValue mt-3">{reference.name || '-'}</Col>
                  </Row>
                  <Row>
                    <Col className="professionalMembershipSubTitle mt-3">Organisation</Col>
                    <Col className="professionalMembershipValue mt-3">{reference.organisation || '-'}</Col>
                  </Row>
                  <Row>
                    <Col className="professionalMembershipSubTitle mt-3">Mobile Number</Col>
                    <Col className="professionalMembershipValue mt-3">{reference.phoneNumber || '-'}</Col>
                  </Row>
                  <Row>
                    <Col className="professionalMembershipSubTitle mt-3">Designation</Col>
                    <Col className="professionalMembershipValue mt-3">{reference.designation || '-'}</Col>
                  </Row>
                  {professionalReferences.length > 1 && index !== professionalReferences.length - 1 && <hr />}
                </div>
              ))
            ) : (
              <div className="noContentMessage"></div>
            )}

          </Card.Body>
        </Card>
      </div>

      {/* Professional Memberships */}
      <div className="membership-card">
        <Card>
          <Card.Body className={`professionalMembershipPanel pd-1 ${professionalMemberships?.length === 0 ? 'emptyCard' : ''}`}>
            <div className="d-flex justify-content-between align-items-center">
              <h5 className="professionalMembershipTitle">Professional Membership</h5>
              {professionalMemberships?.length > 0 ? (
                <button
                  size="sm"
                  onClick={handleOpenMemModal}
                  className="candidate-profile-edit-button"
                >
                  <FontAwesomeIcon icon={faPen} />
                </button>
              ) : (
                <div
                  className="add-action"
                  onClick={() => setShowAddMemModal(true)}
                  style={{ color: '#F35824', cursor: 'pointer', fontWeight: '500' }}
                >
                  <FontAwesomeIcon icon={faPlusCircle} /> Add Membership
                </div>
              )}
            </div>
            {professionalMemberships?.length > 0 && (
              <div className="w-100 text-end mt-2">
                <div
                  onClick={() => setShowAddMemModal(true)}
                  style={{ color: '#F35824', cursor: 'pointer', fontWeight: '500' }}
                >
                  <FontAwesomeIcon icon={faPlusCircle} /> Add Membership
                </div>
              </div>
            )}

            {professionalMemberships?.length > 0 ? (
              professionalMemberships.map((membership, index) => (
                <div key={index}>
                  <Row>
                    <Col className="professionalMembershipSubTitle mt-3">Name</Col>
                    <Col className="professionalMembershipValue mt-3">{membership.name || '-'}</Col>
                  </Row>
                  <Row>
                    <Col className="professionalMembershipSubTitle mt-3">Member Since</Col>
                    <Col className="professionalMembershipValue mt-3">{membership.year || '-'}</Col>
                  </Row>
                  {/* Show <hr /> only if not the last item and there are multiple items */}
                  {professionalMemberships.length > 1 && index !== professionalMemberships.length - 1 && <hr />}
                </div>
              ))
            ) : (
              <div className="noContentMessage"></div>
            )}
          </Card.Body>
        </Card>
      </div>

      {/* Reference Modal */}
      <Modal show={showRefModal} onHide={handleCloseRefModal} centered backdrop="static" className="candidate-custom-modal" dialogClassName="candidate-custom-modal-dialog">
        <Modal.Header className="flex-column align-items-stretch">
          <div className="d-flex justify-content-between align-items-center w-100">
            <Modal.Title>Edit Professional References</Modal.Title>
            <img
              src={CloseIcon}
              alt="Close"
              onClick={handleCloseRefModal}
              style={{
                cursor: 'pointer',
                width: '24px',
                height: '24px',
              }}
            />
          </div>

        </Modal.Header>
        <Modal.Body>
          {editedReferences.map((ref, index) => (
            <div key={index} className="mb-4 border-bottom position-relative" style={{ paddingBottom: '2.5rem' }}>
              <h6 className="mb-3">Professional Reference {index + 1}</h6>
              <Form.Group className="mb-2">
                <Form.Label>Name <span style={{ color: 'red' }}>*</span></Form.Label>
                <Form.Control
                  style={{ boxShadow: 'none', border: '1px solid #ced4da' }}
                  value={ref.name}
                  onChange={(e) => handleRefChange(index, 'name', e.target.value)}
                  isInvalid={!!errors[`name_${index}`]}
                  spellCheck='false'
                />
                <Form.Control.Feedback type="invalid">
                  {errors[`name_${index}`]}
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="mb-2">
                <Form.Label>Organisation</Form.Label>
                <Form.Control
                  style={{ boxShadow: 'none', border: '1px solid #ced4da' }}
                  value={ref.organisation}
                  onChange={(e) => handleRefChange(index, 'organisation', e.target.value)}
                  isInvalid={!!errors[`organisation_${index}`]}
                  spellCheck='false'
                />
                <Form.Control.Feedback type="invalid">
                  {errors[`organisation_${index}`]}
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="mb-2">
                <Form.Label>Phone Number</Form.Label>
                <Form.Control
                  style={{ boxShadow: 'none', border: '1px solid #ced4da' }}
                  value={ref.phoneNumber}
                  onChange={(e) => handleRefChange(index, 'phoneNumber', e.target.value)}
                  isInvalid={!!errors[`phoneNumber_${index}`]}
                  spellCheck='false'
                />
                <Form.Control.Feedback type="invalid">
                  {errors[`phoneNumber_${index}`]}
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="mb-2">
                <Form.Label>Designation</Form.Label>
                <Form.Control
                  style={{ boxShadow: 'none', border: '1px solid #ced4da' }}
                  value={ref.designation}
                  onChange={(e) => handleRefChange(index, 'designation', e.target.value)}
                  isInvalid={!!errors[`designation_${index}`]}
                  spellCheck='false'
                />
                <Form.Control.Feedback type="invalid">
                  {errors[`designation_${index}`]}
                </Form.Control.Feedback>
              </Form.Group>


              <div
                onClick={() => handleRemoveReference(index)}
                style={{ color: '#F35824', cursor: 'pointer', fontWeight: '500', position: 'absolute', bottom: '0.5rem', right: '0.5rem' }}
              >
                <FontAwesomeIcon icon={faMinusCircle} />
              </div>
            </div>
          ))}
        </Modal.Body>

        <Modal.Footer>
          <button onClick={handleCloseRefModal} className="candidate-profile-edit-cancel">Cancel</button>
          {/* <button
            onClick={async () => {
              setSavingMemberships(true);
              setErrorMessage(null);


              const hasRefErrors = Object.keys(errors).some(key =>
                /^name_|^organisation_|^phoneNumber_|^designation_/.test(key)
              );

              if (hasRefErrors) {
                setErrorMessage("Please fix the field-level validation errors before saving.");
                setSavingMemberships(false);
                return;
              }
              try {
                // await CandidatePostLoginService.submitProfessionalRefs({ professionalRefs: editedReferences });
                await CandidatePostLoginService.submitPanelByType('PROFESSIONAL_REFERENCES', { professionalRefs: editedReferences });

                setProfessionalReferences(editedReferences);
                handleCloseRefModal();
              } catch (err) {
                console.error('Error saving references', err);
                setSaveError('Failed to save references.');
              } finally {
                setSavingMemberships(false);
              }
            }}
            className="candidate-profile-edit-save"
            disabled={savingMemberships}
          >
            {savingMemberships ? 'Saving...' : 'Save'}
          </button> */}
          <button
            onClick={async () => {
              setSavingMemberships(true);
              setErrorMessage(null);

              // Check for missing Name in edited references
              const missingNames = editedReferences
                .map((ref, index) => (!ref.name.trim() ? index + 1 : null))
                .filter(Boolean);

              const hasFieldValidationErrors = Object.keys(errors).some(key =>
                /^name_/.test(key)  // Only check Name field errors
              );

              if (missingNames.length > 0 || hasFieldValidationErrors) {
                const missingMessage = missingNames.length
                  ? `Please fill the Name field for Reference(s): ${missingNames.join(", ")}.`
                  : null;

                const combinedMessage = [
                  missingMessage,
                  hasFieldValidationErrors ? "Please fix the field-level validation errors before saving." : null
                ].filter(Boolean).join("\n\n");

                setErrorMessage(combinedMessage);
                setSavingMemberships(false);
                return;
              }

              try {
                await CandidatePostLoginService.submitPanelByType('PROFESSIONAL_REFERENCES', { professionalRefs: editedReferences });

                setProfessionalReferences(editedReferences);
                handleCloseRefModal();
              } catch (err) {
                console.error('Error saving references', err);
                setSaveError('Failed to save references.');
              } finally {
                setSavingMemberships(false);
              }
            }}
            className="candidate-profile-edit-save"
            disabled={savingMemberships}
          >
            {savingMemberships ? 'Saving...' : 'Save'}
          </button>


        </Modal.Footer>
      </Modal>

      {/* Membership Modal */}
      <Modal show={showMemModal} onHide={handleCloseMemModal} centered backdrop="static" className="candidate-custom-modal" dialogClassName="candidate-custom-modal-dialog">
        <Modal.Header className="flex-column align-items-stretch">
          <div className="d-flex justify-content-between align-items-center w-100">
            <Modal.Title>Edit Professional Memberships</Modal.Title>
            <img
              src={CloseIcon}
              alt="Close"
              onClick={handleCloseMemModal}
              style={{
                cursor: 'pointer',
                width: '24px',
                height: '24px',
              }}
            />
          </div>

        </Modal.Header>
        <Modal.Body>
          <style>
            {`
    .react-datepicker__input-container input {
      border: 1px solid #ced4da !important;
      box-shadow: none !important;
    }

    .react-datepicker__input-container input:focus {
      border: 1px solid #ced4da !important;
      box-shadow: none !important;
      outline: none;
    }
  `}
          </style>

          {editedMemberships.map((mem, index) => (
            <div key={index} className="mb-4 border-bottom position-relative" style={{ paddingBottom: '2.5rem' }}>
              <h6 className="mb-3">Professional Membership {index + 1}</h6>
              <Form.Group className="mb-2">
                <Form.Label>Name<span style={{ color: 'red' }}>*</span></Form.Label>
                <Form.Control
                  value={mem.name}
                  onChange={(e) => handleMemChange(index, 'name', e.target.value)}
                  isInvalid={!!errors[`membership_name_${index}`]}
                  spellCheck='false'
                />
                <Form.Control.Feedback type="invalid">
                  {errors[`membership_name_${index}`]}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group className="mb-2" >
                <Form.Label>Member Since</Form.Label>
                <ReactDatePicker
                  name={`editedMemberships.${index}.year`}
                  maxDate={new Date()}
                  onChange={(val) => {
                    if (val) {
                      handleMemChange(index, 'year', val.getFullYear());
                    } else {
                      handleMemChange(index, 'year', null);
                    }
                  }}
                  onKeyDown={(e) => {
                    const allowedKeys = [
                      'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'
                    ];

                    if (
                      !/^\d$/.test(e.key) &&
                      !allowedKeys.includes(e.key)
                    ) {
                      e.preventDefault();
                    }
                  }}
                  className="form-control"
                  style={{ boxShadow: 'none', border: '1px solid #ced4da' }}
                  selected={
                    mem.year ? new Date(new Date().setFullYear(mem.year)) : null
                  }
                  dateFormat="yyyy"
                  showYearPicker
                  autoComplete="off"
                />

              </Form.Group>


              <div
                onClick={() => handleRemoveMembership(index)}
                style={{ color: '#F35824', cursor: 'pointer', fontWeight: '500', position: 'absolute', bottom: '0.5rem', right: '0.5rem' }}
              >
                <FontAwesomeIcon icon={faMinusCircle} />
              </div>
            </div>
          ))}
        </Modal.Body>

        <Modal.Footer>
          <button onClick={handleCloseMemModal} className="candidate-profile-edit-cancel">Cancel</button>
          <button
            onClick={async () => {
              setSavingMemberships(true);
              setErrorMessage(null);

              const missingFieldsPerMembership = editedMemberships.map((mem, index) => {
                const missing = [];
                if (!mem.name.trim()) missing.push("Name");
                // if (!mem.year) missing.push("Member Since");
                return { index: index + 1, missing };
              }).filter(entry => entry.missing.length > 0);
              const hasFieldValidationErrors = Object.keys(errors).some(key =>
                key.startsWith("membership_") && errors[key]
              );

              if (missingFieldsPerMembership.length > 0 || hasFieldValidationErrors) {
                const missingLines = missingFieldsPerMembership.map(
                  entry => `Membership ${entry.index}: ${entry.missing.join(", ")}`
                );
                const combinedMessage = [
                  missingLines.length ? `Please fill all required fields:\n- ${missingLines.join("\n- ")}` : null,
                  hasFieldValidationErrors ? "Please fix the field-level validation errors before saving." : null
                ].filter(Boolean).join("\n\n");

                setErrorMessage(combinedMessage);
                setSavingMemberships(false);
                return;
              }

              try {
                // await CandidatePostLoginService.submitProfessionalMemberships(editedMemberships);
                await CandidatePostLoginService.submitPanelByType('PROFESSIONAL_MEMBERSHIPS', {
                  inputName: 'professionalMemberships',
                  inputList: editedMemberships
                });

                setProfessionalMemberships(editedMemberships);
                handleCloseMemModal();
              } catch (err) {
                console.error('Error saving memberships', err);
                setSaveError('Failed to save memberships.');
              } finally {
                setSavingMemberships(false);
              }
            }}
            className="candidate-profile-edit-save"
            disabled={savingMemberships}
          >
            {savingMemberships ? 'Saving...' : 'Save'}
          </button>

        </Modal.Footer>
      </Modal>

      <Modal show={showAddRefModal} onHide={() => setShowAddRefModal(false)} centered backdrop="static" className="candidate-custom-modal" dialogClassName="candidate-custom-modal-dialog">
        <Modal.Header className="flex-column align-items-stretch">
          <div className="d-flex justify-content-between align-items-center w-100">
            <Modal.Title>Add Professional References</Modal.Title>
            <img
              src={CloseIcon}
              alt="Close"
              onClick={handleCloseAddRefModal}
              style={{
                cursor: 'pointer',
                width: '24px',
                height: '24px',
              }}
            />
          </div>

        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-2">
            <Form.Label>Name <span style={{ color: 'red' }}>*</span></Form.Label>
            <Form.Control
              value={newReference.name}
              onChange={(e) => {
                const value = e.target.value;
                setNewReference(prev => ({ ...prev, name: value }));
                validateField('add', 'name', value);
              }}
              isInvalid={!!errors['name_add']}
              spellCheck="false"
            />
            <Form.Control.Feedback type="invalid">
              {errors['name_add']}
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group className="mb-2">
            <Form.Label>Organisation</Form.Label>
            <Form.Control
              value={newReference.organisation}
              onChange={(e) => {
                const value = e.target.value;
                setNewReference(prev => ({ ...prev, organisation: value }));
                validateField('add', 'organisation', value);
              }}
              isInvalid={!!errors['organisation_add']}
              spellCheck="false"
            />
            <Form.Control.Feedback type="invalid">
              {errors['organisation_add']}
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group className="mb-2">
            <Form.Label>Phone Number <span style={{ color: 'red' }}></span></Form.Label>
            <Form.Control
              value={newReference.phoneNumber}
              onChange={(e) => {
                const value = e.target.value;
                setNewReference(prev => ({ ...prev, phoneNumber: value }));
                validateField('add', 'phoneNumber', value);
              }}
              isInvalid={!!errors['phoneNumber_add']}
              style={{ boxShadow: 'none', border: '1px solid #ced4da' }}
              spellCheck="false"
            />
            <Form.Control.Feedback type="invalid">
              {errors['phoneNumber_add']}
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group className="mb-2">
            <Form.Label>Designation</Form.Label>
            <Form.Control
              value={newReference.designation}
              onChange={(e) => {
                const value = e.target.value;
                setNewReference(prev => ({ ...prev, designation: value }));
                validateField('add', 'designation', value);
              }}
              isInvalid={!!errors['designation_add']}
              spellCheck="false"
            />
            <Form.Control.Feedback type="invalid">
              {errors['designation_add']}
            </Form.Control.Feedback>
          </Form.Group>

        </Modal.Body>
        <Modal.Footer>
          <button onClick={() => setShowAddRefModal(false)} className="candidate-profile-edit-cancel">
            Cancel
          </button>
          {/* <button
            className="candidate-profile-edit-save"
            disabled={savingReference}
            onClick={async () => {
              setSavingReference(true);
              setErrorMessage(null);
              const tempErrors = {};

              const phone = newReference.phoneNumber.trim();
              if (phone && !/^\+\d{1,4}\d{10}$/.test(phone)) {
                tempErrors.phoneNumber_add = 'Enter a valid phone number (e.g. +919012345678).';
              }

              if (Object.keys(tempErrors).length > 0) {
                setErrors(tempErrors);
                setSavingReference(false);
                return;
              }

              try {
                const updatedRefs = [...(professionalReferences || []), newReference];

                // await CandidatePostLoginService.submitProfessionalRefs({ professionalRefs: updatedRefs });
                await CandidatePostLoginService.submitPanelByType('PROFESSIONAL_REFERENCES', { professionalRefs: updatedRefs });

                setEditedReferences(updatedRefs);
                setProfessionalReferences(updatedRefs);
                setNewReference({ name: '', organisation: '', phoneNumber: '', designation: '' });
                setErrors({});
                setShowAddRefModal(false);
              } catch (err) {
                console.error('Failed to save reference:', err);
                setSaveError('Failed to save reference.');
              } finally {
                setSavingReference(false);
              }
            }}
          >
            {savingReference ? 'Saving...' : 'Save'}
          </button> */}

          <button
            className="candidate-profile-edit-save"
            disabled={savingReference}
            onClick={async () => {
              setSavingReference(true);
              setErrorMessage(null);

              const tempErrors = {};
              const missingFields = [];

              // Name required validation
              if (!newReference.name.trim()) {
                tempErrors.name_add = 'Name is required.';
                missingFields.push('Name');
              }

              // Optional validations
              const phone = newReference.phoneNumber.trim();
              if (phone && !/^\+\d{1,4}\d{10}$/.test(phone)) {
                tempErrors.phoneNumber_add = 'Enter a valid phone number (e.g. +919012345678).';
              }

              // Set inline errors first
              setErrors(tempErrors);

              // If any required field missing, show popup at top
              if (missingFields.length > 0) {
                const message = `Please fill all required fields:\n- ${missingFields.join('\n- ')}`;
                setErrorMessage(message);
                setSavingReference(false);
                return;
              }

              try {
                const updatedRefs = [...(professionalReferences || []), newReference];

                await CandidatePostLoginService.submitPanelByType('PROFESSIONAL_REFERENCES', { professionalRefs: updatedRefs });

                setEditedReferences(updatedRefs);
                setProfessionalReferences(updatedRefs);
                setNewReference({ name: '', organisation: '', phoneNumber: '', designation: '' });
                setErrors({});
                setShowAddRefModal(false);
              } catch (err) {
                console.error('Failed to save reference:', err);
                setSaveError('Failed to save reference.');
              } finally {
                setSavingReference(false);
              }
            }}
          >
            {savingReference ? 'Saving...' : 'Save'}
          </button>

        </Modal.Footer>

      </Modal>

      <Modal show={showAddMemModal} onHide={() => setShowAddMemModal(false)} centered backdrop="static" className="candidate-custom-modal" dialogClassName="candidate-custom-modal-dialog">
        <Modal.Header className="flex-column align-items-stretch">
          <div className="d-flex justify-content-between align-items-center w-100">
            <Modal.Title>Add Professional Memberships</Modal.Title>
            <img
              src={CloseIcon}
              alt="Close"
              onClick={handleCloseAddMemModal}
              style={{
                cursor: 'pointer',
                width: '24px',
                height: '24px',
              }}
            />
          </div>


        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-2">
            <Form.Label>Name <span style={{ color: 'red' }}>*</span></Form.Label>
            <Form.Control
              value={newMembership.name}
              onChange={(e) => {
                const name = e.target.value;
                setNewMembership(prev => ({ ...prev, name }));

                setErrors(prev => {
                  const updated = { ...prev };
                  if (!name.trim()) {
                    updated.add_membership_name = 'Name is required.';
                  } else if (!/^[A-Za-z\s]{2,50}$/.test(name.trim())) {
                    updated.add_membership_name = 'Name must be 2-50 alphabetic characters only.';
                  } else {
                    delete updated.add_membership_name;
                  }
                  return updated;
                });
              }}
              isInvalid={!!errors.add_membership_name}
            />
            <Form.Control.Feedback type="invalid">
              {errors.add_membership_name}
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group className="mb-2">
            <Form.Label>Member Since</Form.Label>
            <ReactDatePicker
              name="add_membership_year"
              maxDate={new Date()}
              selected={
                newMembership.year
                  ? new Date(new Date().setFullYear(newMembership.year))
                  : null
              }
              onChange={(val) => {
                const year = val ? val.getFullYear() : '';
                setNewMembership(prev => ({ ...prev, year }));

                setErrors(prev => {
                  const updated = { ...prev };
                  if (year) {
                    // updated.add_membership_year = 'Year is required.';
                    if (year < 1900 || year > new Date().getFullYear()) {
                      updated.add_membership_year = `Year must be between 1900 and ${new Date().getFullYear()}.`;
                    } else {
                      delete updated.add_membership_year;
                    }
                  } else {
                    // Remove error if field is empty
                    delete updated.add_membership_year;
                  }
                  return updated;
                });
              }}
              onKeyDown={(e) => {
                const allowedKeys = [
                  'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'
                ];
                if (!/^\d$/.test(e.key) && !allowedKeys.includes(e.key)) {
                  e.preventDefault();
                }
              }}
              className={`form-control ${errors.add_membership_year ? 'is-invalid' : ''}`}
              dateFormat="yyyy"
              showYearPicker
              autoComplete="off"
              placeholderText="Select year"
            />
            {errors.add_membership_year && (
              <div className="invalid-feedback d-block">
                {errors.add_membership_year}
              </div>
            )}
          </Form.Group>


        </Modal.Body>
        <Modal.Footer>
          <button onClick={() => setShowAddMemModal(false)} className="candidate-profile-edit-cancel">
            Cancel
          </button>
          <button
            className="candidate-profile-edit-save"
            disabled={savingMembership}
            onClick={async () => {
              setSavingMembership(true);
              setErrorMessage(null);
              const tempErrors = {};

              if (!newMembership.name.trim()) {
                tempErrors.add_membership_name = 'Name is required.';
              } else if (!/^[A-Za-z\s]{2,50}$/.test(newMembership.name.trim())) {
                tempErrors.add_membership_name = 'Name must be 2-50 alphabetic characters only.';
              }

              if (newMembership.year) {
                const currentYear = new Date().getFullYear();
                const year = parseInt(newMembership.year, 10);
                if (isNaN(year) || year < 1900 || year > currentYear) {
                  tempErrors.add_membership_year = `Year must be between 1900 and ${currentYear}.`;
                }
              }
              if (Object.keys(tempErrors).length > 0) {
                setErrors(tempErrors);
                setSavingMembership(false);
                return;
              }

              try {
                const updatedMemberships = [...(professionalMemberships || []), newMembership];

                // await CandidatePostLoginService.submitProfessionalMemberships(updatedMemberships);
                await CandidatePostLoginService.submitPanelByType('PROFESSIONAL_MEMBERSHIPS', {
                  inputName: 'professionalMemberships',
                  inputList: updatedMemberships
                });

                setEditedMemberships(updatedMemberships);
                setProfessionalMemberships(updatedMemberships);

                setNewMembership({ name: '', year: '' });
                setErrors({});
                setShowAddMemModal(false);
              } catch (err) {
                console.error('Failed to save membership:', err);
                setSaveError('Failed to save membership.');
              } finally {
                setSavingMembership(false);
              }
            }}
          >
            {savingMembership ? 'Saving...' : 'Save'}
          </button>
        </Modal.Footer>

      </Modal>
    </div>
  );
};

export default CandidateProfessionalMembershipContent;